import { Base64 } from 'js-base64';

export default (string) => {
  let params;
  try {
    params = JSON.parse(Base64.decode(string));
  } catch (e) {
    return false;
  }
  return params;
};
